/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Create_AccountInputs */

const en_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

const es_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu cuenta`)
};

const fr_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre compte`)
};

const de_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle dein Konto`)
};

const ja_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成する`)
};

const zh_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建您的账号`)
};

const ar_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ حسابك`)
};

const id_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat akun Anda`)
};

const it_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo account`)
};

const ru_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте свой аккаунт`)
};

const pt_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie a sua conta`)
};

const ko_auth_create_account = /** @type {(inputs: Auth_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 생성`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Auth_Create_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_create_account = /** @type {((inputs?: Auth_Create_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Create_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_create_account(inputs)
	if (locale === "es") return es_auth_create_account(inputs)
	if (locale === "fr") return fr_auth_create_account(inputs)
	if (locale === "de") return de_auth_create_account(inputs)
	if (locale === "ja") return ja_auth_create_account(inputs)
	if (locale === "zh") return zh_auth_create_account(inputs)
	if (locale === "ar") return ar_auth_create_account(inputs)
	if (locale === "id") return id_auth_create_account(inputs)
	if (locale === "it") return it_auth_create_account(inputs)
	if (locale === "ru") return ru_auth_create_account(inputs)
	if (locale === "pt") return pt_auth_create_account(inputs)
	return ko_auth_create_account(inputs)
});